import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ShowContributorInstructionsStore = {
  customerAuditShowInstructions: boolean;
  setCustomerAuditShowInstructions: (customerAuditShowInstructions: boolean) => void;
};

export const useShowContributorInstructionsStore = create<ShowContributorInstructionsStore>()(
  persist(
    set => ({
      customerAuditShowInstructions: false,
      setCustomerAuditShowInstructions: (customerAuditShowInstructions: boolean) => {
        set({ customerAuditShowInstructions });
      },
    }),
    {
      name: 'chat-show-contributor-instructions',
    },
  ),
);
